import { Component, Input } from '@angular/core';
import { trackReports } from '../../../../core/constants/constants';
import { TrackMXSummaryResponse } from '../../../../core/interface/mx-reports';
import { VarianceReportData } from '../../../../core/interface/export-reports';

@Component({
  standalone: false,
  selector: 'app-track-mx-summary',
  templateUrl: './track-mx-summary.component.html',
  styleUrl: './track-mx-summary.component.less',
})
export class TrackMxSummaryComponent {
  trackReport = trackReports;
  @Input()
  trackMXSummaryResponse!: TrackMXSummaryResponse;
  @Input()
  reportData!: VarianceReportData;
}
